// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"eM-z","smallCardRow":"fM-z","largeCardRow":"gM-z","productSearchRow":"hM-z","curatedRow":"iM-z"};